if (typeof window.MattressFAQs === 'undefined') {
    window.MattressFAQs = class MattressFAQs extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
      }
  
      connectedCallback() {
        if (this.isConnected && !this.initialized) {
          this.initialized = true;
          this.triggers = this.querySelectorAll('.MattressFAQs__Question');
          this.panels = this.querySelectorAll('.MattressFAQs__AnswerWrapper');
  
          this.initDrawers();
        }
      }
  
      initDrawers() {
        this.triggers.forEach(trigger => trigger.addEventListener('click', (e) => {
          const drawerIndex = trigger.dataset.index;
          const matchingPanel =
            Array.from(this.panels).find(p => p.dataset.index === drawerIndex);
  
          NUtils.slideToggle(matchingPanel);
  
          NUtils.toggleBooleanAttribute(trigger, 'aria-expanded');
          NUtils.toggleBooleanAttribute(matchingPanel, 'aria-hidden');
        }));
      }
    }
    customElements.define('mattress-faqs', MattressFAQs);
  }